exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#slidelisteditor-fab-bar{position:absolute;top:48px;right:25px;display:flex;align-items:center;justify-content:flex-end}#slidelisteditor-fab-bar .fab{float:left;margin-left:10px}.slidelisteditor-slide:hover .slidelisteditor-slide-menu{display:block}.slidelisteditor-slide-menu{display:none;position:absolute;right:10px;top:12px}.slidelisteditor-slide-menu-action:hover{color:#000!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js?outputStyle=expanded!./src/styles/SlideListEditor.scss
// module id = 332
// module chunks = 0